import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import { getSize, getColor } from '@lib/common';
import styled from '@xstyled/styled-components';
import { Checkbox } from 'antd';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledAnswerItemLayout = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: ", ";\n  width: 100%;\n"])), getSize('padding12'));
var StyledAnswerCheckbox = styled(Checkbox)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex: 1;\n  cursor: default;\n\n  align-self: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  padding: 12px;\n  border-radius: ", ";\n  border: 1px solid ", ";\n\n  background-color: ", ";\n\n  .ant-checkbox {\n    top: 0 !important;\n  }\n\n  span.ant-checkbox + * {\n    flex: 1;\n    top: 0 !important;\n    height: auto;\n    padding-right: 0;\n    display: flex;\n    align-items: center;\n    flex-wrap: nowrap;\n  }\n\n  .ant-checkbox-inner {\n    width: 18px;\n    height: 18px;\n    background-color: #f8fafc;\n    border-color: #cbd5e1;\n  }\n\n  .ant-checkbox-checked .ant-checkbox-inner {\n    background-color: ", ";\n    border-color: ", ";\n  }\n\n  .ant-checkbox-checked .ant-checkbox-inner::after {\n    border-color: ", ";\n  }\n"])), getSize('padding8'), function (_ref) {
  var $isSelected = _ref.$isSelected;
  return $isSelected ? getColor('fillIntActive') : '#cbd5e1';
}, function (_ref2) {
  var $isSelected = _ref2.$isSelected;
  return $isSelected ? '#faf8fc' : '#ffffff';
}, getColor('fillIntActive'), getColor('fillIntActive'), getColor('fillBgWhite'));
var StyledAnswerPrefix = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 500;\n  color: ", ";\n  margin-right: ", ";\n  white-space: nowrap;\n"])), getSize('typo14'), function (_ref3) {
  var $isSelected = _ref3.$isSelected;
  return $isSelected ? '#2664EB' : '#334155';
}, getSize('padding8'));
var StyledDescription = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  flex: 1;\n"])));
export var AnswerItem = function AnswerItem(_ref4) {
  var index = _ref4.index,
      values = _ref4.values;
  return /*#__PURE__*/_jsx(StyledAnswerItemLayout, {
    children: /*#__PURE__*/_jsxs(StyledAnswerCheckbox, {
      checked: values.isSelected,
      $isSelected: values.isSelected,
      disabled: true,
      children: [/*#__PURE__*/_jsxs(StyledAnswerPrefix, {
        $isSelected: values.isSelected,
        children: [String.fromCharCode(65 + index), "."]
      }), /*#__PURE__*/_jsx(StyledDescription, {
        children: values.description
      })]
    })
  });
};